<template>
  <div>
    <div v-show="listing" class="app-content content ">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header row">
          <div class="content-header-left col-md-9 col-12 mb-2">
            <Breadcrumb
              name="Payment Link"
              bc1="App"
              bc2="Payment Link"
              bc3="List"
            ></Breadcrumb>
          </div>
          <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
          >
          </div>
        </div>
        <div class="content-body">
          <div class="card" v-if="showAllFilters">
            <h5 class="card-header">Search Filter</h5>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-6 user_plan">
                <SelectOptions
                    label=""
                    selectAppend="currency"
                    labelValue="code"
                    :filter="{ flag: 'active' }"
                    :modelValue.sync="selectedAccount"
                    :url="showSelectAccountOption"
                />
              </div>
              <div class="col-md-6 user_status">
                <input class="form-control mt-sm-50" @keyup.enter="onSubmitFilters" type="text" v-model="search" placeholder="Search here..."/>
              </div>

            </div>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-6 mb-1 user_plan">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="">
                      <label>Select Store</label>
                      <SearchSelect
                          v-model="selectedStore"
                          url="v1/get-store"
                          :filterParams="{ status: 1 }"
                          :customLabelFn="customStoreNameForMultiselect"
                          placeholder="Search Store..."
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 mb-1 user_plan">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <label>Select Terminal</label>
                      <multiselect
                          v-model="selectedTerminal"
                          :options="terminalData"
                          label="label"
                          track-by="id"
                          placeholder="Select Terminal"
                          :loading="terminalLoader"
                          variant="primary"
                          :custom-label="customStoreNameForMultiselect"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6 user_plan">
                <div class="form-group row">
                  <div class="col-sm-12">
                    <div class="input-group">
                      <label>Select Channel</label>
                      <multiselect
                          v-model="selectedChannel"
                          :options="channelData"
                          label="label"
                          track-by="id"
                          placeholder="Select Channel"
                          :loading="channelLoader"
                          variant="primary"
                          :custom-label="customStoreNameForMultiselect"
                      ></multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-md-4 user_status">
                <date-picker
                    v-model="fromDate"
                    :disabledDate="disableFutureDates"
                    valueType="format"
                    :lang="lang"
                    name="fromDate"
                    placeholder="choose start date"
                ></date-picker>
              </div>
              <div class="col-md-4 user_status">
                <date-picker
                    v-model="toDate"
                    :disabledDate="disableFutureDates"
                    valueType="format"
                    :lang="lang"
                    name="toDate"
                    placeholder="choose end date"
                ></date-picker>
              </div>
              <div class="col-md-4 user_status">
                <button type="button" class="btn btn-primary" @click="onSubmitFilters" >Search</button>
                <button type="button" class="ml-1 btn btn-danger "  @click="clear">Clear</button>
              </div>

            </div>
          </div>
          <div class="card">
            <CommonTable
              :url="url"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :deleteActions="deleteActions"
              :mutedData="mutedData"
              :storageKey="storageKey"
              :externalTotalRecord="externalTotalRecord"
              :filteredData="filteredData"
              :exportData="exportData"
              :show-per-page="true"
              @getFullResponse="getFullResponse"
            />
          </div>
        </div>
      </div>
    </div>
    <paymentTransaction v-if="!listing" :rowData="rowData"
                        @backFromDetailPage="backFromDetailPage"/>
    <DetailTextModal :show="showDescriptionModal" :text="description"
                     @hide="showDescriptionModal = false" />
  </div>
</template>


<script>

// import ToastificationContent from "@/components/common/ToastificationContent";
// import {useToast} from "vue-toastification";
import paymentTransaction from "@/pages/dashboard/payment-link/paymentTransaction";
import DatePicker from "vue2-datepicker";
import SearchSelect from "@/components/common/SearchSelect.vue";
import DetailTextModal from "@/components/common/modals/DetailTextModal.vue";

export default {
  components: {DetailTextModal, SearchSelect, paymentTransaction,DatePicker},
  mounted() {
    this.showSelectAccountOption = 'v1/get-currency'
    this.showSelectTypesOption = 'v1/transaction-types'

    localStorage.setItem("url", "v1/get-payment-link");
    this.checkDataInStore('v1/get-payment-link')
    if (
      typeof this.$route.params.update == "undefined" &&
      typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
    this.startCountdown();
  },
  data() {
    return {
      exportData: {
        cta: (exportType) => {
          let requestData = {
            exportAs: exportType,
            reportType: 'payment_links',
            // payment_type: 1,
          }


          this.downloadReport(requestData)
        }
      },
      listing: true,
      rowData: [],
      url: "v1/get-payment-link",
      storageKey: "paymentLink",
      showConfirmationModal: false,
      // toastG: useToast(),
      currentRow: null,
      currentIndex: null,
      description:'',
      showDescriptionModal:false,
      tableHeaderValues: [
        {
          title: 'Id',
          valueKey: 'token',
          html: true,
          alter: function (value, row) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              if (row.added_by && row.added_by_user) {
                if (row.added_by != row.user_id) {
                  html = `
                <div class="row">
                <div class="col-12">
                <span class="text-primary ">${value}</span>
                </div><p><div class="badge badge-light-danger ml-1" style="margin-top: 0.3rem">${row.added_by_user.email + '/' + row.added_by_user.first_name + ' ' + row.added_by_user.last_name}</div></p></div>`
                }
              }
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: 'Total Transactions',
          valueKey: 'transactions_count',
          html: true,
          alter: function (value) {
            var html = ''
            html = `<span class="text-info">${value}</span>`


            return html


          }
        },
        {
          title: 'Amount',
          valueKey: 'amount',
          html: true,
          customClass: 'text-center',
          alter: (value, obj) => {
            var html = ''
            if (value && obj.type == 0)
              html = `<span  class=" font-weight-bolder text-dark row justify-content-center">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))} <div class="badge badge-light-success ml-1">${obj.currency.code}</div></span>
               <div class="badge badge-light-warning mt-1">Single</div>`
            else if (value && obj.type == 1) {
              html = `<span  class=" font-weight-bolder text-dark row justify-content-center">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))} <div class="badge badge-light-success ml-1">${obj.currency.code}</div></span>
               <div class="badge badge-light-info mt-1">Multiple</div>`
            }

            // html += `<div class="badge badge-light-success mt-1">${obj.currency.code}</div>`

            return html


          }
        },
        {
          title: 'Schemas',
          valueKey: 'schemas',
          html: true,
          alter: function (value, obj) {
            var html = ''
            if (value) {
              html = `<div class="grid">`
              if (obj.schemas.length) {
                obj.schemas.forEach((item) => {

                  html += `<div class="row"><div class="badge badge-light-primary mt-sm-1">${item.name}</div></div>`
                })
              }

              html += ` </div>`
            }


            return html
          }
        },
        {
          title: "Description",
          valueKey: "description",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-danger" style="cursor: pointer" title="click to view full description">${value.substring(0,12)+'...'}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          },
          cta: (row) => {
            this.description = row.description
            this.showDescriptionModal = true
          }
        },
        {
          title: 'Callback Url',
          valueKey: 'callback_url',
        },
        {
          title: 'User',
          valueKey: 'user',
          html: true,
          alter: (value, row) => {
            var html = '-'
            if (value) {
              html = `<span class="text-primary">${value.email + '/' + value.first_name}</span>`
            }

            return html
          }
        },
        {
          title: 'Status',
          valueKey: 'exipres_in',
          html: true,
          alter:  (value, obj) => {
            var givenDate = new Date(obj.created_at);
            var givenSeconds = givenDate.getTime() / 1000;
            var currentDate = new Date();
            var currentSeconds = currentDate.getTime() / 1000;
            var html = ''
            if(!obj.exipres_in){
              html = `<div class="badge badge-light-dark" style="margin-top: 0.5rem">Lifetime</div>`
            }
            else if ((obj.exipres_in < (currentSeconds-givenSeconds))) {
              html = `

                <div class="badge badge-light-danger ml-1 " style="margin-top: 0.5rem">Expired</div>`

            }else{
              // let expiry = parseFloat(obj.exipres_in-(currentSeconds-givenSeconds)).toString()
              html = `<span class="countdown-timer" data-expires="${obj.exipres_in}" data-created="${obj.created_at}"></span>`
              // html = `<div class="badge badge-light-warning ml-1" style="margin-top: 0.5rem">${expiry.split('.')[0]} seconds left</div>\``
            }

            let statusHtml = ''
            if (obj.status == 1)
              statusHtml = `<div class="badge badge-pill dynamic-status  badge-glow badge-success">${obj.status_str}</div>`
            else if (obj.status == 2)
              statusHtml = `<div class="badge badge-pill dynamic-status  badge-glow badge-danger">${obj.status_str}</div>`
            else
              statusHtml = `<div class="badge badge-pill dynamic-status  badge-glow badge-warning"">${obj.status_str}</div>`


            if(!obj.exipres_in){
              html = `
                <div class="row justify-content-center">
                    <div class="">
                    ${statusHtml}
                    </div>
                ${html}
                </div>`
            }
            else if((obj.exipres_in < (currentSeconds-givenSeconds))){
              // means expired
              html = `
                <div class="row justify-content-center">
                ${html}
                </div>`
            }else{
              html = `
                <div class="row justify-content-center">
                    <div class="">
                    ${statusHtml}
                    </div>
                ${html}
                </div>`
            }


            return html


          },
        },
        {
          title: 'Transaction Time/Date',
          valueKey: 'created_at',
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [
        // {
        //   conditionalRendering: true,
        //   toggleSwitch:true,
        //   class: 'mt-1',
        //   toggleSwitchCondition: (row) => {
        //     if (row.status == 1) {
        //       return true
        //     }
        //     return false
        //   },
        //   condition: (row) => {
        //     if (row.status == 1 || row.status == 2) {
        //       return true
        //     }
        //     return false
        //   },
        //   cta: (row, index) => {
        //     this.updateStatus(row, index)
        //     // this.currentRow = row
        //     // this.currentIndex = index
        //     // this.showConfirmationModal = true
        //   }
        // },
        {
          title: 'Transactions',
          class: 'btn-warning mt-1',
          cta: (row, index) => {
            this.listing = false
            this.rowData = row
          }
        },
        {
          title: "copy Link",
          class: "btn badge btn-outline-info round waves-effect btn-sm mt-1",
          cta: row => {
            this.copyLink(row);
          }
        },
        {
          title: 'Attempts',
          class: 'btn-primary mt-1 ml-1',
          cta: (row) => {
            this.$router.push({name: 'payment-link-attempt',params: {id:row.token}})
          }
        },
      ],
      mutedData: [],
      deleteActions: [],
      externalTotalRecord: "",
      filteredData: {paymentType:1},
      fromDate: null,
      toDate: null,
      selectedAccount: null,
      selectedType: null,
      showSelectAccountOption: '',
      showSelectTypesOption: '',
      transactionTypes: [],
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      selectedMerchant: null,
      selectedStore: null,
      selectedTerminal: null,
      selectedChannel: null,
      storeData: [],
      terminalData: [],
      channelData: [],
      terminalLoader:false,
      channelLoader:false,
      search: '',
      showAllFilters:false,
    }
  },
  methods: {
    startCountdown() {
      this.countdownInterval = setInterval(() => {
        document.querySelectorAll('.countdown-timer').forEach((element) => {
          let expiresIn = parseInt(element.getAttribute('data-expires'));
          let createdAt = new Date(element.getAttribute('data-created')).getTime();
          let currentTime = new Date().getTime();
          let elapsedSeconds = Math.floor((currentTime - createdAt) / 1000);
          let remainingSeconds = expiresIn - elapsedSeconds;

          // Find the closest row and the dynamic status element
          let row = element.closest('tr');
          let statusElement = row ? row.querySelector('.dynamic-status') : null;

          if (remainingSeconds <= 0) {
            // Clear the status if it exists
            if (statusElement) {
              statusElement.innerHTML = "";
            }
            element.innerHTML = `<span class="badge badge-light-danger ml-1" style="margin-top: 0.5rem">Expired</span>`;
          } else {
            element.innerHTML = `<small style="margin-top: 0.5rem" class=" font-weight-bolder row  text-danger justify-content-center">Expires In</small><span class="badge badge-light-warning" style="margin-top: 0.5rem">${this.formatTime(remainingSeconds)}</span>`;
          }
        });
      }, 1000);

    },

    formatTime(seconds) {
      let days = Math.floor(seconds / (3600 * 24));
      let hours = Math.floor((seconds % (3600 * 24)) / 3600);
      let minutes = Math.floor((seconds % 3600) / 60);
      let sec = seconds % 60;

      return `${days}d ${hours}h ${minutes}m ${sec}s`;
    },
    getFullResponse(){
      this.showAllFilters=true
    },
    onSubmitFilters() {

      let filterData = {paymentType:1}

      if(this.selectedStore){
        filterData.storeId = this.selectedStore.id
      }
      if(this.selectedTerminal){
        filterData.terminalId = this.selectedTerminal.id
      }
      if(this.selectedChannel){
        filterData.channelId = this.selectedChannel.id
      }

      if(this.selectedType){
        filterData.transactionTypeId = this.selectedType.id
      }
      if(this.selectedAccount){
        filterData.currencyId = this.selectedAccount.id
      }
      if(this.search != ''){
        filterData.transactionId = this.search
      }
      if(this.toDate){
        filterData.toDate = this.toDate
      }
      if(this.fromDate){
        filterData.fromDate = this.fromDate
      }



      this.filteredData = filterData




    },
    clear(){
      this.selectedType = null
      this.selectedAccount = null
      this.toDate = null
      this.fromDate = null
      this.search = ''
      this.selectedStore = null
      this.selectedTerminal = null
      this.selectedChannel = null
      this.filteredData = {paymentType:1}

    },
    getTerminalData() {
      this.terminalLoader = true
      this.makeRequest("post", "v1/get-terminal", {storeId:this.selectedStore?this.selectedStore.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.terminalData = responseData;
                }
                else{
                  this.terminalData = []
                }
                // this.setSelectedTerminalValue();
              }
            }
            this.terminalLoader = false
          }
      );
    },
    setSelectedTerminalValue() {


      if (this.selectedTerminal == null && this.terminalData.length > 0) {
        this.selectedTerminal = this.terminalData[0];

      }
      else{
        this.selectedTerminal = null
      }
    },
    getChannelData() {
      this.channelLoader = true
      this.makeRequest("post", "v1/get-channel", {storeId:this.selectedStore?this.selectedStore.id:'',terminalId:this.selectedTerminal?this.selectedTerminal.id:'',status:1}, {}, false,true,[205]).then(
          (callResponse) => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              let responseData = callResponse.response.data.data;
              if (code == 200) {
                if(responseData){
                  this.channelData = responseData;
                }
                else{
                  this.channelData = []
                }
                // this.setSelectedChannelValue();
              }
            }
            this.channelLoader = false
          }
      );
    },
    setSelectedChannelValue() {
      if (this.selectedChannel == null && this.channelData.length > 0) {
        this.selectedChannel = this.channelData[0];

      }
      else{
        this.selectedChannel = null
      }
    },
    customStoreNameForMultiselect ({ name,code }) {
      return `${name}/${code}`
    },
    backFromDetailPage() {
      this.listing = true
    },

    confirm() {
      let data = {
        paymentLinkId: this.currentRow.id
      };
      if (this.currentRow.status == 2) {
        data.status = 1
      } else {
        data.status = 2
      }
      this.makeRequest('post', 'v1/update-payment-link', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.showConfirmationModal = false
            this.mutedData = {
              index: this.currentIndex,
              status_str: callResponse.response.data.data.status_str,
              status: data.status
            }
          }
          // this.currentIndex = null
          // this.currentRow = null
        }

      });


    },
    updateStatus(row, index) {
      let data = {
        paymentLinkId: row.id
      };
      if (row.status == 2) {
        data.status = 1
      } else {
        data.status = 2
      }

      this.makeRequest('post', 'v1/update-payment-link', data).then(callResponse => {

        this.loader = false
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.mutedData = {
              index: index,
              status_str: callResponse.response.data.data.status_str,
              status: data.status
            }
          }
        }

      });

    },
    copyLink(row) {
      this.copyText(row.payment_url,true);
    }
  },
  watch: {
    selectedStore(val) {
      this.selectedTerminal = null
      if(!val){
        this.terminalData = []
        return
      }
      this.getTerminalData()
    },
    selectedTerminal(val) {
      this.selectedChannel = null
      if(!val){
        this.channelData = []
        return
      }
      this.getChannelData()
    },
  }
}
</script>

